import {VImage} from "./vet-clinic.model";

/**
 * Model reprezentujący pojedynczy baner reklamowy/promocyjny Partnera Biznesowego.
 * Używany w module In-App Advertising do zarządzania rotacją i wyświetlaniem
 * kreacji reklamowych w aplikacji mobilnej.
 */
export class PartnerBanner {

  /** Globalnie unikalny identyfikator banera. */
  public uuid: string;

  /** Data i czas utworzenia. */
  public created: Date;

  /** Data i czas ostatniej modyfikacji. */
  public modified: Date;

  /**
   * Tagi reguł targetowania.
   * Np. wartości: "ANTYBIOTYK, SZCZEPIONKA".
   */
  public ruleTags: string;

  /**
   * Obiekt grafiki banera.
   */
  public image: VImage;

  /** Identyfikator wgranego pliku graficznego. */
  public imageUUID: string;

  /**
   * UUID Klienta Biznesowego (w tym wypadku Partnera), do którego należy ten baner.
   * Klucz obcy łączący kreację z kontem reklamodawcy (model `Partner`).
   */
  public partnerVClientUUID: string;

  constructor() {
  }
}
